import script from "./NewsfeedInlineVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedInlineVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedInlineVideoPlayer.vue?vue&type=style&index=0&id=453b2e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453b2e80"]])

export default __exports__